import { Instructor } from "../../providers/instructorsProvider";
import { Student } from "../../providers/studentsProvider";
import { BookedTraining } from "../../model/BookedTraining";
import { PostalAddress } from "../../model/PostalAddress";
import { StudentSelect } from "../../inputs/StudentSelect";
import { BookedTrainingSelect } from "../../inputs/BookedTrainingSelect";
import { DrivingLessonStartLocationSelect } from "../../inputs/DrivingLessonStartLocationSelect";
import { Row } from "../Row";
import { Box, Button, IconButton, Typography } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { autovioColors } from "../backofficeTheme";

interface InstructorCalendarRecommendationFilterProps {
  instructor: Instructor;
  selectedStudent?: Student;
  selectedBookedTraining?: BookedTraining;
  setSelectedStudent: (student: Student | undefined) => void;
  setSelectedBookedTraining: (bookedTraining: BookedTraining | undefined) => void;
  setSelectedStartLocation: (postalAddress: PostalAddress | undefined) => void;
  setShowRecommendationFilters: (state: boolean) => void;
}
export const InstructorCalendarRecommendationFilter = ({
  instructor,
  selectedStudent,
  selectedBookedTraining,
  setSelectedStudent,
  setSelectedBookedTraining,
  setSelectedStartLocation,
  setShowRecommendationFilters,
}: InstructorCalendarRecommendationFilterProps) => {
  const close = () => setShowRecommendationFilters(false);
  const selectSx = {
    minWidth: 0,
    width: "100%",
  };

  return (
    <Row
      data-testid="instructor-calendar-recommendation-filter"
      sx={{
        alignItems: { xs: "stretch", sm: "center" },
        display: "grid",
        gap: { xs: 1, sm: "30px" },
        gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "auto minmax(0, 1fr) auto" },
        minWidth: 0,
        width: "100%",
      }}
    >
      <Row sx={{ alignItems: "center", justifyContent: "space-between", width: { xs: "100%", sm: "auto" } }}>
        <Typography fontSize="15px" lineHeight={1.2} fontWeight={600}>
          <Box component="span" sx={{ display: { xs: "inline", sm: "none" } }}>
            Terminvorschläge:
          </Box>
          <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
            Termin-
            <br />
            vorschläge:
          </Box>
        </Typography>
        <IconButton
          aria-label="Terminvorschläge schließen"
          onClick={close}
          size="small"
          sx={{ display: { xs: "inline-flex", sm: "none" } }}
        >
          <ClearIcon />
        </IconButton>
      </Row>
      <Row
        sx={{
          alignItems: { xs: "stretch", sm: "center" },
          display: "grid",
          gap: { xs: 1, sm: "16px" },
          gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(auto-fit, minmax(250px, 1fr))" },
          minWidth: 0,
          width: "100%",
        }}
      >
        <StudentSelect
          label="Fahrschüler"
          sx={selectSx}
          size="small"
          onChange={(student) => setSelectedStudent(student ?? undefined)}
          instructorId={instructor.id}
          value={selectedStudent}
        />
        {selectedStudent && (
          <BookedTrainingSelect
            sx={{ ...selectSx, margin: 0 }}
            student={selectedStudent}
            onChange={setSelectedBookedTraining}
            value={selectedBookedTraining ?? selectedStudent.activeOrMostRecentBookedTraining}
          />
        )}
        {selectedStudent && instructor.drivingSchoolId && (
          <DrivingLessonStartLocationSelect
            sx={selectSx}
            onChange={(postalAddress) => setSelectedStartLocation(postalAddress ?? undefined)}
            instructorId={instructor.id}
            studentId={selectedStudent.id}
            drivingSchoolId={instructor.drivingSchoolId}
          />
        )}
      </Row>
      <Button
        onClick={close}
        sx={{
          textTransform: "none",
          color: autovioColors.green,
          display: { xs: "none", sm: "inline-flex" },
        }}
        endIcon={<ClearIcon />}
      >
        Schließen
      </Button>
    </Row>
  );
};
